export var transitionDurationInSec = 0.2;
export var LEFT = 'left';
export var RIGHT = 'right';
export var MIDDLE = 'middle';